import { call, put } from 'redux-saga/effects';
import { setPasswordHandoutError, setPasswordHandoutThrottled } from '../actions';
import { showAlert } from 'phoenix2/state/alert/sagas';
import log from 'loglevel';

// Error codes
const NOT_FOUND = 404;
const INVALID_DATA = 401;

const TOO_MANY_REQUESTS = 429;

// Should the user be shown a validation error?
const shouldShowValidationError = (statusCode: number): boolean =>
    [NOT_FOUND, INVALID_DATA].indexOf(statusCode) > -1;

// Handle errors coming back from the server. Either show a validation message
// or a server error alert modal
export function* handleServerError(errorResponse: any) {
    if (errorResponse.statusCode && shouldShowValidationError(errorResponse.statusCode)) {
        yield put(setPasswordHandoutError());
    } else if (errorResponse.statusCode === TOO_MANY_REQUESTS) {
        yield put(setPasswordHandoutThrottled());
    } else {
        if (process.env.NODE_ENV !== 'test') {
            log.error('Unexpected error with password handout request', errorResponse);
        }
        yield call(showAlert, {
            title: 'Oops!',
            message: 'There was a problem submitting your information. Please try again later.',
        });
    }
}
